/**
 * Gives `evalJs` the worker it runs expressions in. Import this before anything evaluates an
 * expression.
 */
import { setBrowserWorkerFactory } from '@squaredup/js-eval';
import ScriptWorker from '@squaredup/js-eval/script.worker?worker';

setBrowserWorkerFactory((): Worker => new ScriptWorker());
